import { ADDITIONAL_DATA_KEY, MAIN_DATA_KEY, X_AXIS_LABEL_KEY } from 'consts/chart'

import { Timestamp, ValueOf } from './common'

export type ChartItem = {
  name: string
  value: string
  color: string
}

export type ChartItemWitSelection = ChartItem & {
  selected?: boolean
}

export type ChartDataValue = {
  value: number
  hasData: boolean
}

export type ChartDataValues = Record<string, ChartDataValue>

export type ChartData = {
  [X_AXIS_LABEL_KEY]: string
  date: number
  [MAIN_DATA_KEY]: ChartDataValues
  [ADDITIONAL_DATA_KEY]?: ChartDataValues
}[]

export type ChartProps = {
  data: ChartData
  charts: ChartItem[]
  entityName: string
  additionCharts?: ChartItem[]
  primaryLabel?: string
  additionLabel?: string
  selectedCharts?: string[]
  height?: number
}

export type BarChartLegendItem = ChartItem & { selected: boolean }

export const RangeDirection = {
  Previous: 'Previous',
  Next: 'Next',
} as const

export type RangeDirection = ValueOf<typeof RangeDirection>

export type TableDataItem = {
  name: string
  value?: string
  subRows?: TableDataItem[]
} & Record<number, ChartDataValue>

export type ChartTableProps = {
  data: ChartData
  charts: ChartItem[]
  selectedCharts: string[]
  entityName?: string
  additionalData?: ChartData
  additionalDataLabel?: string
  onSelectCharts: (newSelectedCharts: string[]) => void
}

export type DataKey<T extends StatisticBase, K extends keyof T> =
  | K
  | ((data: T) => string)
export type StatisticBase = { date?: Timestamp; time?: Timestamp }
